/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Storefront_Not_Found_DescInputs */

const en_storefront_not_found_desc = /** @type {(inputs: Storefront_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This seller's storefront doesn't exist or hasn't been set up yet.`)
};

const es_storefront_not_found_desc = /** @type {(inputs: Storefront_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tienda de este vendedor no existe o aún no ha sido configurada.`)
};

const fr_storefront_not_found_desc = /** @type {(inputs: Storefront_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La vitrine de ce vendeur n'existe pas ou n'a pas encore été configurée.`)
};

const de_storefront_not_found_desc = /** @type {(inputs: Storefront_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Storefront dieses Verkäufers existiert nicht oder wurde noch nicht eingerichtet.`)
};

const ja_storefront_not_found_desc = /** @type {(inputs: Storefront_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この出品者のストアフロントは存在しないか、まだ設定されていません。`)
};

const zh_storefront_not_found_desc = /** @type {(inputs: Storefront_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该卖家的店铺不存在或尚未设置。`)
};

const ar_storefront_not_found_desc = /** @type {(inputs: Storefront_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهة هذا البائع غير موجودة أو لم يتم إعدادها بعد.`)
};

const id_storefront_not_found_desc = /** @type {(inputs: Storefront_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etalase penjual ini tidak ada atau belum disiapkan.`)
};

const it_storefront_not_found_desc = /** @type {(inputs: Storefront_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La vetrina di questo venditore non esiste o non è stata ancora configurata.`)
};

const ru_storefront_not_found_desc = /** @type {(inputs: Storefront_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Витрина этого продавца не существует или еще не настроена.`)
};

const pt_storefront_not_found_desc = /** @type {(inputs: Storefront_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A vitrine deste vendedor não existe ou ainda não foi configurada.`)
};

const ko_storefront_not_found_desc = /** @type {(inputs: Storefront_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`해당 판매자의 스토어프론트가 존재하지 않거나 아직 설정되지 않았습니다.`)
};

/**
* | output |
* | --- |
* | "This seller's storefront doesn't exist or hasn't been set up yet." |
*
* @param {Storefront_Not_Found_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const storefront_not_found_desc = /** @type {((inputs?: Storefront_Not_Found_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storefront_Not_Found_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_storefront_not_found_desc(inputs)
	if (locale === "es") return es_storefront_not_found_desc(inputs)
	if (locale === "fr") return fr_storefront_not_found_desc(inputs)
	if (locale === "de") return de_storefront_not_found_desc(inputs)
	if (locale === "ja") return ja_storefront_not_found_desc(inputs)
	if (locale === "zh") return zh_storefront_not_found_desc(inputs)
	if (locale === "ar") return ar_storefront_not_found_desc(inputs)
	if (locale === "id") return id_storefront_not_found_desc(inputs)
	if (locale === "it") return it_storefront_not_found_desc(inputs)
	if (locale === "ru") return ru_storefront_not_found_desc(inputs)
	if (locale === "pt") return pt_storefront_not_found_desc(inputs)
	return ko_storefront_not_found_desc(inputs)
});